import { Component, OnInit, Input, ViewChild, EventEmitter, Output } from '@angular/core';
import { ContextDiscoveryEventBusService, SiteService } from '../../context-discovery-services/services';
import { AzureBlobUploadService } from '../../context-discovery-services/services/azure-blob-upload.service';
import { Message } from '../../context-discovery-services/models';
import { Storage } from '../../context-discovery-services/models';
import { SeverityType } from '../../context-discovery-services/constants/severity-type.const';
import { HistoryValidationService } from '../../context-discovery-services/services/history-validation.service';
import { HistoryConfigStatus } from '../../context-discovery-services/enums/history-config-status';
import { Subscription } from 'rxjs';
import { EventLoggerService } from '../../context-discovery-services/services/event-logger.service';
import { EventLoggerActivity } from '../../context-discovery-services/enums/event-logger-activity';

@Component({
  selector: 'adminapp-upload-history-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {
  private _modelId: string;
  uploadFileDisabled: boolean;
  file: File;
  selectFile;
  storageInfo: Storage;
  _isSetupAnalyticsComplete: boolean;
  _historyValidationStatus: HistoryConfigStatus;
  historyConfigParams: any;
  isGetPointsWithMissingHistoryInProgress: boolean;
  uploadHistoryForegroundLoading: boolean;
  _isAssetIdentificationFailed: boolean;
  _isContextDiscoveryInProgress: boolean;
  _isAssetIdentificationRequired: boolean;
  _isSiteData1UploadRequired: boolean;
  _isPublishInProgress: boolean;
  _isHistoryPublishFailed: boolean;
  _isHistoryPublishCompleted: boolean;
  _isUploadCancelled: boolean = false;
  isLoadingHistoryFileName: boolean;
  _isHistoryPublishFeatureEnabled: boolean;
  _isHistoryValidationFeatureEnabled: boolean;
  _isUnifiedFlowEnabled: boolean;
  uploadToBlobStorageSubscription: Subscription;
  _assetIdentificationText = 'Identification';
  _isHistoryFileUploadFailed: boolean = false;

  @ViewChild('uploadZipModal') uploadZipModal: any;
  @ViewChild('uploadHistory') uploadHistory: any;
  @ViewChild('validateButton') validateButton: any;
  @ViewChild('publishHistoryButton') publishHistoryButton: any;
  @ViewChild('publishHistoryConfirmationModal') publishHistoryConfirmationModal: any;
  @ViewChild('validateHistoryModal') validateHistoryModal: any;

  @Output()
  historyValidationStartedEventEmitter: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  historyPublishStartedEventEmitter: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  viewAssetsEventEmitter: EventEmitter<void> = new EventEmitter<void>();

  @Input()
  set isHistoryPublishFeatureEnabled(historyPublishFeatureEnabled: boolean) {
    if (this._isHistoryPublishFeatureEnabled !== historyPublishFeatureEnabled) {
      this._isHistoryPublishFeatureEnabled = historyPublishFeatureEnabled;
    }
  }

  @Input()
  set isHistoryValidationFeatureEnabled(historyValidationFeatureEnabled: boolean) {
    if (this._isHistoryValidationFeatureEnabled !== historyValidationFeatureEnabled) {
      this._isHistoryValidationFeatureEnabled = historyValidationFeatureEnabled;
    }
  }

  @Input()
  set isUnifiedFlowEnabled(unifiedFlowEnabled: boolean) {
    if (this._isUnifiedFlowEnabled !== unifiedFlowEnabled) {
      this._isUnifiedFlowEnabled = unifiedFlowEnabled;
      this._assetIdentificationText = this._isUnifiedFlowEnabled ? 'Discovery' : 'Identification';
    }
  }

  @Input()
  set modelId(idOfModel: string) {
    if (this._modelId === idOfModel) {
      return;
    }
    this._modelId = idOfModel;
  }

  @Input()
  set isSetupAnalyticsComplete(isSetupAnalyticsComplete: boolean) {
    if (this._isSetupAnalyticsComplete !== isSetupAnalyticsComplete) {
      this._isSetupAnalyticsComplete = isSetupAnalyticsComplete;
    }
  }

  @Input()
  set historyValidationStatus(historyValidationStatus: HistoryConfigStatus) {
    if (this._historyValidationStatus !== historyValidationStatus) {
      this._historyValidationStatus = historyValidationStatus;
      this.invokePointsWithMissingHistoryRetrieval();
    }
  }

  @Input()
  set isAssetIdentificationFailed(showAssetIdentificationFailed: boolean) {
    if (this._isAssetIdentificationFailed !== showAssetIdentificationFailed) {
      this._isAssetIdentificationFailed = showAssetIdentificationFailed;
    }
  }

  @Input()
  set isHistoryPublishFailed(showHistoryPublishFailed: boolean) {
    if (this._isHistoryPublishFailed !== showHistoryPublishFailed) {
      this._isHistoryPublishFailed = showHistoryPublishFailed;
    }
  }

  @Input()
  set isHistoryPublishCompleted(showHistoryPublishCompleted: boolean) {
    if (this._isHistoryPublishCompleted !== showHistoryPublishCompleted) {
      this._isHistoryPublishCompleted = showHistoryPublishCompleted;
    }
  }

  @Input()
  set isContextDiscoveryInProgress(assetIdentificationInProgress: boolean) {
    if (this._isContextDiscoveryInProgress !== assetIdentificationInProgress) {
      this._isContextDiscoveryInProgress = assetIdentificationInProgress;
    }
  }

  @Input()
  set isSiteData1UploadRequired(siteData1UploadRequired: boolean) {
    if (this._isSiteData1UploadRequired !== siteData1UploadRequired) {
      this._isSiteData1UploadRequired = siteData1UploadRequired;
    }
  }

  @Input()
  set isAssetIdentificationRequired(assetIdentificationRequired: boolean) {
    if (this._isAssetIdentificationRequired !== assetIdentificationRequired) {
      this._isAssetIdentificationRequired = assetIdentificationRequired;
    }
  }

  @Input()
  set isPublishInProgress(publishInProgress: boolean) {
    if (this._isPublishInProgress !== publishInProgress) {
      this._isPublishInProgress = publishInProgress;
    }
  }

  constructor(private azureBlobUploadService: AzureBlobUploadService,
    private eventBusService: ContextDiscoveryEventBusService, private historyValidationService: HistoryValidationService,
    private siteService: SiteService, private eventLoggerService: EventLoggerService) {
    this.eventBusService.serverMessage$.subscribe((message: Message) => {
      const uploadHistoryToast: any = document.getElementById(message.severityType + 'UploadHistory');
      uploadHistoryToast.text = message.content;
      uploadHistoryToast.open();
    });
  }

  ngOnInit() {
    this.validateButton.nativeElement.addEventListener('click', this.onValidateClick.bind(this));
    this.publishHistoryButton.nativeElement.addEventListener('click', this.onPublishHistoryClicked.bind(this));
    this.initialize();
  }

  initialize() {
    this.isLoadingHistoryFileName = true;
    this.historyValidationService.getHistoryFileName().subscribe(this.getHistoryFileNameSuccessCallback.bind(this),
      this.getHistoryFileNameFailureCallback.bind(this));
  }

  getStorageInfoSuccessCallback(storageInfo: Storage): any {
    this.storageInfo = storageInfo;
    this.uploadFileToBlob();
  }

  uploadFileToBlob() {
    const metadata = {
      FILENAME: this.file.name
    };
    if (this.storageInfo !== null) {
      this.uploadToBlobStorageSubscription
        = this.azureBlobUploadService.uploadToBlobStorage(this.file, this.storageInfo, metadata).subscribe(_ => {
        }, error => {
          this.eventLoggerService.logFailureEvent(EventLoggerActivity.UPLOAD_SITE_DATA_3, 'History upload failed')
            .subscribe(this.eventLoggerSuccessCallback.bind(this), this.eventLoggerFailureCallback.bind(this));
          this.onErrorDuringUpload(error);
        }, () => {
          this.onUploadComplete();
        });
    }
  }

  getStorageInfoFailureCallback(): any {
    this._isHistoryFileUploadFailed = true;
    this.eventLoggerService.logFailureEvent(EventLoggerActivity.UPLOAD_SITE_DATA_3, 'History upload failed')
      .subscribe(this.eventLoggerSuccessCallback.bind(this), this.eventLoggerFailureCallback.bind(this));
    this.closeUploadZipModal();
    this.showErrorOperationToast('Failed to upload file. Please try again later.');
  }

  getHistoryFileNameSuccessCallback(response) {
    if (response.FileName) {
      this.selectFile = response.FileName;
    } else {
      this.selectFile = '';
    }
    this.isLoadingHistoryFileName = false;
  }

  getHistoryFileNameFailureCallback(): any {
    this.showErrorOperationToast('Failed to retreive history file name');
    this.selectFile = '';
    this.isLoadingHistoryFileName = false;
  }

  onFileZipSelected(file: File) {
    this.file = file;
    this.eventLoggerService.logStartedEvent(EventLoggerActivity.UPLOAD_SITE_DATA_3, 'Started history upload')
      .subscribe(this.eventLoggerSuccessCallback.bind(this), this.eventLoggerFailureCallback.bind(this));
    this.openUploadZipModal();
    this.onUploadZip();
  }

  onErrorDuringFileSelect() {
    this._isHistoryFileUploadFailed = true;
    this.showInformationOperationToast('Please select a valid file');
  }

  onUploadZip() {
    if (this.file !== null) {
      this.historyValidationService.getStorageInfo()
        .subscribe(this.getStorageInfoSuccessCallback.bind(this), this.getStorageInfoFailureCallback.bind(this));
    }
  }

  onErrorDuringUpload(errorMessage) {
    this._isHistoryFileUploadFailed = true;
    this.uploadToBlobStorageSubscription.unsubscribe();
    this.closeUploadZipModal();
    this.showErrorOperationToast(errorMessage);
  }

  onZipUploadCancel() {
    this._isUploadCancelled = true;
    this.azureBlobUploadService.cancelUpload();
    this.uploadToBlobStorageSubscription.unsubscribe();
    this.closeUploadZipModal();
    this.showInformationOperationToast('Upload file cancelled');
    this.eventLoggerService.logFailureEvent(EventLoggerActivity.UPLOAD_SITE_DATA_3, 'History upload failed')
      .subscribe(this.eventLoggerSuccessCallback.bind(this), this.eventLoggerFailureCallback.bind(this));
  }

  onUploadComplete() {
    if (this._isUploadCancelled === false) {
      const fileName: string = this.file.name;
      this.uploadToBlobStorageSubscription.unsubscribe();
      this._isHistoryFileUploadFailed = false;
      this.closeUploadZipModal();
      this.startForegroundLoading();
      this.historyValidationService.putFileUploadCompleted().subscribe(this.fileUpdateSuccessCallback.bind(this, fileName),
        this.fileUpdateCompletedFailureCallback.bind(this));
    } else {
      this._isUploadCancelled = false;
    }
  }

  fileUpdateSuccessCallback(fileName) {
    this.stopForegroundLoading();
    this.showSuccessOperationToast('Successfully uploaded file');
    this.selectFile = fileName;
    this.historyConfigParams = {
      status: HistoryConfigStatus.BLOB_UPLOADED,
      nextActionButtonText: this.getNextActionButtonText(HistoryConfigStatus.BLOB_UPLOADED)
    };
    this.eventLoggerService.logSuccessEvent(EventLoggerActivity.UPLOAD_SITE_DATA_3, 'History upload completed')
      .subscribe(this.eventLoggerSuccessCallback.bind(this), this.eventLoggerFailureCallback.bind(this));
  }

  fileUpdateCompletedFailureCallback() {
    this.stopForegroundLoading();
    this.eventLoggerService.logFailureEvent(EventLoggerActivity.UPLOAD_SITE_DATA_3, 'History upload failed')
      .subscribe(this.eventLoggerSuccessCallback.bind(this), this.eventLoggerFailureCallback.bind(this));
    this.showErrorOperationToast('Something went wrong. Please upload the file again.');
    this.historyConfigParams = {
      status: HistoryConfigStatus.NOT_AVAILABLE,
      nextActionButtonText: this.getNextActionButtonText(HistoryConfigStatus.NOT_AVAILABLE)
    };
  }

  openUploadZipModal() {
    this.uploadZipModal.open();
  }

  closeUploadZipModal() {
    this.uploadZipModal.close();
  }
  showSuccessOperationToast(message: string) {
    this.eventBusService.sendMessage(new Message(message, SeverityType.SUCCESS));
  }

  showInformationOperationToast(message: string) {
    this.eventBusService.sendMessage(new Message(message, SeverityType.INFORMATION));
  }

  showErrorOperationToast(message: string) {
    this.eventBusService.sendMessage(new Message(message, SeverityType.CRITICAL));
  }

  onValidateClick() {
    this.startForegroundLoading();
    this.historyValidationService.validateHistoryZip().subscribe(this.historyValidationSuccessCallback.bind(this),
      this.historyValidationFailureCallback.bind(this));
  }

  historyValidationSuccessCallback() {
    this.stopForegroundLoading();
    this.historyValidationStartedEventEmitter.emit({});
  }

  historyValidationFailureCallback() {
    this.stopForegroundLoading();
    this.showErrorOperationToast('Failed to start validation');
  }

  handlePublishHistoryEvent() {
    this._isHistoryPublishFailed = false;
    this.startForegroundLoading();
    this.siteService.publishHistory().subscribe(this.publishHistorySuccessCallback.bind(this),
      this.publishHistoryFailureCallback.bind(this));
  }

  publishHistorySuccessCallback() {
    this.stopForegroundLoading();
    this.historyPublishStartedEventEmitter.emit({});
  }

  publishHistoryFailureCallback() {
    this.stopForegroundLoading();
    this.showErrorOperationToast('Failed to start history publish');
  }

  onPublishHistoryClicked() {
    this.publishHistoryConfirmationModal.open();
  }

  private invokePointsWithMissingHistoryRetrieval() {
    switch (this._historyValidationStatus) {
      case HistoryConfigStatus.VALIDATION_COMPLETED:
        this.historyConfigParams = {
          status: this._historyValidationStatus
        };
        this.isGetPointsWithMissingHistoryInProgress = true;
        this.historyValidationService.getPointsWithMissingHistory()
          .subscribe(this.pointsWithMissingHistoryRetrievalSuccessCallback.bind(this),
            this.pointsWithMissingHistoryRetrievalFailureCallback.bind(this));
        break;
      default:
        this.historyConfigParams = {
          status: this._historyValidationStatus,
          nextActionButtonText: this.getNextActionButtonText(this._historyValidationStatus)
        };
    }
  }

  pointsWithMissingHistoryRetrievalSuccessCallback(missingPoints: Array<string>) {
    this.isGetPointsWithMissingHistoryInProgress = false;
    this.historyConfigParams = {
      status: HistoryConfigStatus.VALIDATION_COMPLETED_RETRIEVAL_COMPLETED,
      pointsWithMissingHistory: missingPoints
    };
  }

  pointsWithMissingHistoryRetrievalFailureCallback() {
    this.showErrorOperationToast('Failed to retrieve points with missing history');
    this.isGetPointsWithMissingHistoryInProgress = false;
    this.historyConfigParams = {
      status: HistoryConfigStatus.VALIDATION_COMPLETED_RETRIEVAL_FAILED,
      nextActionButtonText: this.getNextActionButtonText(HistoryConfigStatus.VALIDATION_COMPLETED_RETRIEVAL_FAILED)
    };
  }

  startForegroundLoading() {
    this.uploadHistoryForegroundLoading = true;
  }

  stopForegroundLoading() {
    this.uploadHistoryForegroundLoading = false;
  }

  onGoToViewAssets() {
    if (this.viewAssetsEventEmitter) {
      this.viewAssetsEventEmitter.emit();
    }
  }

  private getNextActionButtonText(status: HistoryConfigStatus) {
    switch (status) {
      case HistoryConfigStatus.NOT_AVAILABLE:
        return this.uploadHistory.browseButton.nativeElement.textContent;
      case HistoryConfigStatus.BLOB_UPLOADED:
      case HistoryConfigStatus.VALIDATION_COMPLETED_RETRIEVAL_FAILED:
        return this.validateButton.nativeElement.textContent;
      default:
        return undefined;
    }
  }

  canEnableHistoryValidation() {
    return (!this._isAssetIdentificationFailed && !this._isContextDiscoveryInProgress && !this._isAssetIdentificationRequired
      && !this._isSiteData1UploadRequired && !this._isPublishInProgress && !this.isHistoryUploadDataNotAvailable());
  }

  canEnableHistoryPublish() {
    return (this.canEnableHistoryValidation() &&
    (this.historyConfigParams && (this.historyConfigParams.status === HistoryConfigStatus.VALIDATION_COMPLETED ||
      this.historyConfigParams.status === HistoryConfigStatus.VALIDATION_COMPLETED_RETRIEVAL_COMPLETED ||
      this.historyConfigParams.status === HistoryConfigStatus.VALIDATION_COMPLETED_RETRIEVAL_FAILED)));
  }

  isHistoryValidationFailed() {
    return (this.historyConfigParams &&
      (this.historyConfigParams.status === HistoryConfigStatus.VALIDATION_COMPLETED_WITH_ERRORS ||
      this.historyConfigParams.status === HistoryConfigStatus.VALIDATION_COMPLETED_RETRIEVAL_FAILED ||
      this.isHistoryConfigurationMissed() ||
      this.historyConfigParams.status === HistoryConfigStatus.MODEL_UPDATE_FAILED ||
      this.historyConfigParams.status === HistoryConfigStatus.ERROR));
  }

  isHistoryValidationSuccessful() {
    return (this.historyConfigParams &&
      (this.historyConfigParams.status === HistoryConfigStatus.VALIDATION_COMPLETED_RETRIEVAL_COMPLETED &&
      this.historyConfigParams.pointsWithMissingHistory && this.historyConfigParams.pointsWithMissingHistory.length === 0));
  }

  isHistoryConfigurationMissed() {
    return (this.historyConfigParams &&
      (this.historyConfigParams.status === HistoryConfigStatus.VALIDATION_COMPLETED_RETRIEVAL_COMPLETED &&
      this.historyConfigParams.pointsWithMissingHistory && this.historyConfigParams.pointsWithMissingHistory.length > 0));
  }

  isHistoryUploadDataNotAvailable() {
    return (this.historyConfigParams && this.historyConfigParams.status === HistoryConfigStatus.NOT_AVAILABLE);
  }

  eventLoggerSuccessCallback() {

  }

  eventLoggerFailureCallback() {

  }
}
